
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512.001 512.001"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M156.683 411.479h-22.274v-19.652c0-8.907-7.246-16.153-16.153-16.153H82.367c-8.907 0-16.153 7.246-16.153 16.153v19.652H43.941c-6.244 0-11.307 5.063-11.307 11.307v77.906c0 6.245 5.063 11.307 11.307 11.307h112.741c6.244 0 11.307-5.063 11.307-11.307v-77.906c0-6.245-5.062-11.307-11.306-11.307zm-39.838 0H83.78v-18.24h33.065v18.24z"}}),_c('circle',{attrs:{"cx":"259.839","cy":"42.141","r":"42.141"}}),_c('path',{attrs:{"d":"M467.168 326.163h-9.066v-54.005h7.442a4.022 4.022 0 004.022-4.022V254.73a4.022 4.022 0 00-4.022-4.022H412.71c2.989-8.683-.201-18.595-8.286-23.747l-41.732-26.595-.331-54.776c-.133-26.399-21.718-47.876-48.118-47.876H205.084c-26.4 0-47.985 21.477-48.118 47.876l-.751 149.38c-.057 11.23 9.001 20.379 20.23 20.435h.104c11.181 0 20.275-9.037 20.331-20.23l.751-149.38a3.925 3.925 0 017.851.018l.009 341.787c0 13.476 10.924 24.4 24.4 24.4 13.476 0 24.4-10.924 24.4-24.4V292.57h10.534v195.029c0 13.476 10.924 24.4 24.4 24.4 13.476 0 24.4-10.924 24.4-24.4 0-318.415-.432-143.909-.443-341.647a4.257 4.257 0 018.51-.14v.002l.398 65.869a20.328 20.328 0 009.405 17.024l45.98 29.302v10.125a4.022 4.022 0 004.022 4.022h7.442v54.005h-9.066c-6.738 0-12.199 5.462-12.199 12.199v139.941c0 6.738 5.462 12.199 12.199 12.199h9.066v13.177a8.322 8.322 0 0016.642 0V490.5h35.877v13.177a8.322 8.322 0 0016.642 0V490.5h9.065c6.738 0 12.199-5.462 12.199-12.199v-139.94c.002-6.737-5.458-12.198-12.196-12.198zm-25.708 0h-35.873v-54.005h35.873v54.005z"}})])
          )
        }
      }
    